import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Typography, Box, Button } from "@mui/material";
import { UploadButton } from "../../../components/Buttons";
import { useTranslation } from "react-i18next";

export default ({ onLogoUpload, logo, clearLogo }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [policyLogo, setPolicyLogo] = useState(null);

  const minLogoSize = { h: 67 };
  const minSizeText = { minSize: `${minLogoSize.h} px` };
  const minLogoSizeError = () =>
    alert(t("policySettings.minLogoSizeError", minSizeText));
  const minLogoSizeMessage = t("policySettings.minLogoSizeMsg", minSizeText);

  useEffect(() => {
    setPolicyLogo(document.getElementById(logo?.props?.id));
  });

  let handleLogoUpload = event => {
    if (event.target.files) {
      let file = new Image(),
        rawFile = event.target.files[0];
      file.src = URL.createObjectURL(rawFile);
      file.onload = () => {
        const imageTooSmall = file.height < minLogoSize.h;

        if (imageTooSmall) minLogoSizeError();
        else onLogoUpload(file.src, rawFile);
      };
    }

    event.target.value = "";
  };

  return (
    <>
      <Typography variant="h5">{t("policySettings.logoTitle")}</Typography>
      <Box display="flex" alignItems="center" my={2}>
        <Box
          xs={{
            width: policyLogo?.width || 200,
            height: policyLogo?.height || 200
          }}
          mr={3}
          bgcolor={theme.palette.secondary[50]}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {logo}
        </Box>
        <Box display="flex" flexDirection={"column"}>
          <Box
            display="flex"
            flexDirection={"column"}
            style={{ padding: "16px" }}
          >
            <Typography>{minLogoSizeMessage}</Typography>
            <Typography>{t("policySettings.supportedFormats")}</Typography>
          </Box>
          <Box display="flex" justifyContent={"space-between"}>
            <Button
              color="primary"
              onClick={() => clearLogo()}
              disabled={!policyLogo}
            >
              {t("policySettings.clearLogo")}
            </Button>
            <UploadButton
              acceptType="image/*"
              buttonId={2}
              onUpload={handleLogoUpload}
              buttonText={t("policySettings.uploadBtn")}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};
